import './assets/social-icons.css';

const styles = civilCMSClassnames['social-icons'];

const socialIconsConfig = {
  name: 'search-icons',
  options: {
    styles,
  },
};

export default socialIconsConfig;
